export default class CustomPrice {
  init = async () => {
    jQuery(document).ready(function () {
      jQuery(".variations_form").each(function () {
        jQuery(this).on("found_variation", function (event, variation) {
          const price = document.querySelector(".woocommerce-variation-price").innerHTML; //
          document.querySelector(".custom-price").innerHTML = price;
        });
      });
    });
  };
}
